import { Card, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from '@mui/material';
import { countryFields } from 'src/models/country';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import TableSortLabel from '@mui/material/TableSortLabel';
import { useState } from 'react';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });

  return stabilizedThis.map((el) => el[0]);
}

const CountryList = ({
  countries,
  page,
  pagesize,
  handleOnPageChange,
  handleLimitChange,
  totalCountry,
  removeCountry,
  open,
  onOpenModal,
  idCountry,
  setIdCountry,
  onOpenModalCountry,
  setValue
}) => {
  const { t } = useTranslation();
  const [oderDirection, setOrderDirection] = useState('asc');
  const [valueToOderBy, setValueToOderBy] = useState(countryFields.name.label);

  const handleRequestSort = (event, property) => {
    const isAscending = valueToOderBy === property && oderDirection === 'asc';
    setValueToOderBy(property);
    setOrderDirection(isAscending ? 'desc' : 'asc');
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  return (
    <Card>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <TableSortLabel
                active={valueToOderBy === countryFields.name.name}
                direction={valueToOderBy === countryFields.name.name ? oderDirection : 'asc'}
                onClick={createSortHandler(countryFields.name.name)}
              >
                {countryFields.name.label}
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={valueToOderBy === countryFields.code.name}
                direction={valueToOderBy === countryFields.code.name ? oderDirection : 'asc'}
                onClick={createSortHandler(countryFields.code.name)}
              >
                {countryFields.code.label}
              </TableSortLabel>
            </TableCell>
            <TableCell>{countryFields.action.label}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {countries &&
            stableSort(countries, getComparator(oderDirection, valueToOderBy)).map((country) => (
              <TableRow key={country._id}>
                <TableCell>{country.name}</TableCell>
                <TableCell>{country.code}</TableCell>
                <TableCell>
                  <Tooltip title="Edit">
                    <IconButton
                      size="small"
                      aria-label="edit"
                      onClick={() => {
                        onOpenModalCountry(true);
                        setIdCountry(country._id);
                        setValue('name', country.name);
                        setValue('code', country.code);
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton
                      size="small"
                      aria-label="delete"
                      onClick={() => {
                        onOpenModal(true);
                        setIdCountry(country._id);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={totalCountry}
        onPageChange={handleOnPageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={pagesize}
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
      />
      <Dialog open={open} onClose={() => onOpenModal(false)}>
        <DialogTitle>{t('dialog.title')}</DialogTitle>
        <DialogActions>
          <Button onClick={() => onOpenModal(false)}> {t('dialog.noButton')}</Button>
          <Button
            onClick={() => {
              removeCountry(idCountry);
              onOpenModal(false);
            }}
            autoFocus
          >
            {t('dialog.yesButton')}
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};
CountryList.propTypes = {
  countries: PropTypes.array,
  page: PropTypes.number,
  pagesize: PropTypes.number,
  totalCountry: PropTypes.number,
  open: PropTypes.bool,
  onOpenModal: PropTypes.func,
  onOpenModalCountry: PropTypes.func,
  idCountry: PropTypes.string,
  setIdCountry: PropTypes.func,
  removeCountry: PropTypes.func,
  handleOnPageChange: PropTypes.func,
  setValue: PropTypes.func,
  handleLimitChange: PropTypes.func
};
export default CountryList;
